import { avatarConfigV0ToV1 } from '@utils/migrations/v0-to-v1';
export const migrate = (origin) => {
    if (!origin
        .__version) {
        return avatarConfigV0ToV1(origin);
    }
    return origin;
};
